// array.indexOf returns the index of the first value it finds, so all subsequent
// vals will be filtered out
// Note: only good for filtering primitive values due to equality as a test
export default function unique(arr) {
  return arr.filter((v, i, self) => self.indexOf(v) === i);
}
